<template>
  <div class="company-detail">
    <side-bar>
      <header-nav ref="router" :style="style.headerNav" :theme="headerNavbg"></header-nav>
      <base-login @logined="init"></base-login>
      <div class="headerBanner" v-if="company.company_info.office_live">
        <div class="bannerImg">
          <img src="https://o.bysjy.com.cn/kzp/kzp_web/banner360.png" alt="" />
          <p class="titile">360度全景介绍</p>
          <p class="view" @click="getIframeView">进入观看</p>
          <div class="iframeView" v-if="showIframeView">
            <a :href="company.company_info.office_live" :target="company.company_info.company_id + '_720vr'" />
            <iframe :src="company.company_info.office_live + office_live_version"
              style="width: 1200px; height: 510px; border: 0"></iframe>
          </div>
        </div>
      </div>
      <el-container class="container" v-loading="!company.company_info.company_id">
        <el-main>
          <card-base :style="style.cardBase1" :style-object="style.top" :margin-object="style.topMargin"
            v-if="company.company_info.company_id">
            <el-row>
              <el-col :span="18" class="clearfix company-info">
                <div class="fl" style="margin-right: 0.2rem">
                  <el-image
                    style="width: 0.7rem;height: 0.7rem;border: 1px solid #f7f7f7;text-align: center;vertical-align: middle;"
                    :src="company.company_info.logo_url" fit="contain">
                    <div slot="error" class="image-slot">
                      <img class="el-image__inner" style="object-fit: contain" :src="$util.error_company_logo" alt="" />
                    </div>
                  </el-image>
                </div>
                <div class="fl">
                  <p>
                    <span class="text-bold">
                      <global-company-name :type="1" :show_name='true' :status="company.company_info.realname_status"
                        :company_name="company.company_info.company_name"></global-company-name>
                    </span>
                  </p>
                  <p class="card-tip">
                  <section class="credit-item" v-for="(icon, icon_i) in company.icons" v-if="icon.icon_path.length > 1"
                    :key="icon_i">
                    <img :src="icon.icon_path"
                      :class="{ 'icon-credit': icon.icon_class == 'credit', 'icon-vip': icon.icon_class == 'vip', 'icon-vr': icon.icon_class == 'vr' }"
                      :alt="icon.icon_name">
                  </section>
                  </p>
                  <p class="text-introduce">
                    <span class="text-normal" v-show="company.company_info.province">{{ company.company_info.province
                    }}</span>
                    <span class="text-normal" v-show="company.company_info.city_name">{{ company.company_info.city_name
                    }}</span>
                    <span class="text-normal" v-show="company.company_info.industry_category">{{
                      company.company_info.industry_category }}</span>
                    <span class="text-normal" v-show="company.company_info.company_property">{{
                      company.company_info.company_property }}</span>
                  </p>
                </div>
              </el-col>
              <el-col :span="6" class="tr right-info-box">
                <p class="fans-box"><span class="fans-num">{{ funs_count }}</span>粉丝</p>
                <el-popover placement="right" width="250" trigger="hover">
                  <div class="program-popover">
                    <el-image :src="trendsUrl" class="code-img"></el-image>
                    <p>打开【微信】-【扫一扫】查看单位动态</p>
                    <p class="notice-text">关注企业后可查看单位招聘动态</p>
                  </div>
                  <el-button class="follow-btn" slot="reference"
                    :type="is_funs * 1 !== 0 && is_funs != null ? 'info' : 'primary'" size="mini" :plain="false">{{
                      is_funs
                      !== 0 && is_funs != null ? '已关注' : '+ 关注' }}</el-button>
                </el-popover>
                <el-popover placement="right" width="250" trigger="hover">
                  <div class="program-popover">
                    <el-image :src="trendsUrl" class="code-img"></el-image>
                    <p>打开【微信】-【扫一扫】来跟我聊聊吧</p>
                  </div>
                  <el-button slot="reference" icon="el-icon-chat-dot-round" size="mini" type="primary"
                    :plain="false">聊聊</el-button>
                </el-popover>

              </el-col>
            </el-row>
          </card-base>
          <el-row :gutter="20" :style="style.elRow">
            <el-col :span="16">
              <card-base :style-object="style.top" :margin-object="style.topMargin">
                <el-tabs v-model="tabsInfo.active" @tab-click="tabsChangeFn" class="custom" :style="{
                  'min-height': company.company_info.office_live
                    ? '890px'
                    : 'inherit',
                }">
                  <el-tab-pane label="简介" name="info">
                    <div>
                      <h2 class="icon-box" style="margin-top: 0">
                        <span class="icon-circle">
                          <i class="iconfont icongongzuotai"></i>
                        </span>
                        <span class="icon-text">企业介绍</span>
                      </h2>
                      <div class="company-text" style="line-height: 0.24rem" v-if="company.company_info.introduction"
                        v-html="company.company_info.introduction"></div>
                      <no-data v-else></no-data>
                    </div>
                    <div>
                      <h2 class="icon-box">
                        <span class="icon-circle">
                          <i class="iconfont icongongzuotai"></i>
                        </span>
                        <span class="icon-text">公司地址</span>
                      </h2>
                      <!-- <baidu-map :props-style="style.map" ref="baidu-map"></baidu-map> -->
                      <div class="company-text" style="line-height: 0.24rem" >
                        <i class="el-icon-location-outline f16"></i>
                        {{ company.company_info.address }}
                      </div>
                    </div>
                    <div v-if="scene_pics.length > 0">
                      <h2 class="icon-box">
                        <span class="icon-circle">
                          <i class="iconfont icongongzuotai"></i>
                        </span>
                        <span class="icon-text">办公环境</span>
                      </h2>
                      <div>
                        <el-row :gutter="20">
                          <el-col :span="12" v-for="(item, index) in scene_pics" :key="index">
                            <el-image style="height: 2rem" fit="cover" :src="item"
                              :preview-src-list="scene_pics"></el-image>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                    <div v-if="scene_schoolmate_pics.length > 0">
                      <h2 class="icon-box">
                        <span class="icon-circle">
                          <i class="iconfont icongongzuotai"></i>
                        </span>
                        <span class="icon-text">员工风采</span>
                      </h2>
                      <div>
                        <el-row :gutter="20">
                          <el-col :span="12" v-for="(item, index) in scene_schoolmate_pics" :key="index">
                            <el-image style="height: 2rem" fit="cover" :src="item"
                              :preview-src-list="scene_schoolmate_pics"></el-image>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                    <div v-if="company.brand.c_line">
                      <h2 class="icon-box">
                        <span class="icon-circle"><i class="iconfont icongongzuotai"></i></span>
                        <span class="icon-text">乘车路线</span>
                      </h2>
                      <div class="company-text" style="line-height: 0.24rem" v-html="company.brand.c_line"></div>
                    </div>
                    <div v-if="company.brand.c_welfare">
                      <h2 class="icon-box">
                        <span class="icon-circle"><i class="iconfont icongongzuotai"></i></span>
                        <span class="icon-text">薪酬福利</span>
                      </h2>
                      <div class="company-text" style="line-height: 0.24rem" v-html="company.brand.c_welfare"></div>
                    </div>
                    <div v-if="company.brand.c_development">
                      <h2 class="icon-box">
                        <span class="icon-circle"><i class="iconfont icongongzuotai"></i></span>
                        <span class="icon-text">职业发展</span>
                      </h2>
                      <div class="company-text" style="line-height: 0.24rem" v-html="company.brand.c_development"></div>
                    </div>
                    <div v-if="company.brand.c_recruit">
                      <h2 class="icon-box">
                        <span class="icon-circle"><i class="iconfont icongongzuotai"></i></span>
                        <span class="icon-text">招聘流程</span>
                      </h2>
                      <div class="company-text" style="line-height: 0.24rem" v-html="company.brand.c_recruit"></div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="职位" name="job">
                    <div class="infinite-list" :style="
                      'overflow-y:auto; height:' + grid.jobHeight + 'px;'
                    ">
                      <div class="job-list-wrap" v-infinite-scroll="loadNextJobs">
                        <el-row :gutter="20" class="job-list-group"
                          v-if="company.job_list && company.job_list.length > 0">
                          <el-col :span="12" v-for="(item, index) in company.job_list" :key="index">
                            <el-row class="job-list-item">
                              <el-col :span="16" @click.native="jobDetail(item.publish_id)">
                                <p class="text-bold">
                                  <span>{{ item.job_name }}</span>
                                  <span class="tip-txt" v-if="item.create_time">{{
                                    item.create_time | fomartTime
                                  }}发布</span>
                                </p>
                                <p class="text-introduce">
                                  <span class="text-light" style="margin-right: 0.15rem">{{ item.salary }}</span>
                                  <span class="text-normal">{{ item.job_number }}人</span>
                                  <span class="text-normal">{{
                                    item.degree_require
                                  }}</span>
                                  <span class="text-normal">{{
                                    item.city_name
                                  }}</span>
                                </p>
                              </el-col>
                              <el-col :span="8" class="tr" style="padding-top: 0.125rem">
                                <invite-resume :params="item" type="primary" btn-text="立即投递"></invite-resume>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                        <no-data v-else></no-data>
                      </div>
                      <el-row style="height: 50px" v-if="loadingPane" v-loading="loadingPane" element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"></el-row>
                      <el-divider v-if="grid.jobNoData">
                        这是我的底线哦~
                      </el-divider>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="轨迹" name="dynamic">
                    <div class="step-list" :style="
                      'overflow-y:auto;padding:20px; height:' +
                      grid.dynamicHeight +
                      'px;'
                    ">
                      <div class="job-list-wrap" v-infinite-scroll="loadNextDynamic">
                        <el-steps direction="vertical" :active="company.dynamic_list_active" :space="100" v-if="
                          company.dynamic_list &&
                          company.dynamic_list.length > 0
                        ">
                          <el-step v-for="(item, index) in company.dynamic_list" :key="index" :title="item.meet_time_str"
                            icon="el-icon-info">
                            <p slot="description" style="font-size: 14px; font-weight: bold">
                              <el-tag size="mini">{{ item.type }}
                              </el-tag>&nbsp;{{ item.title }}
                            </p>
                          </el-step>
                        </el-steps>
                        <no-data v-else></no-data>
                      </div>

                      <el-row style="height: 50px" v-if="loadingPane" v-loading="loadingPane" element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"></el-row>
                      <el-divider v-if="grid.dynamicNoData">
                        这是我的底线哦~
                      </el-divider>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="互动" name="communication">
                    <div class="input-wrap">
                      <el-input placeholder="提出你的问题，等待HR回答..." v-model="question">
                        <el-button slot="append" :disabled="!!countDownTime" @click="submitQuestion">{{ countDownTime ?
                          countDownTime + 's' : '提问' }}
                        </el-button>
                      </el-input>
                    </div>
                    <div class="infinite-list" :style="
                      'overflow-y:auto; height:' + grid.questionHeight + 'px;'
                    ">
                      <div class="communication-list-wrap" v-infinite-scroll="loadNextQuestion">
                        <template v-if="
                          company.communication &&
                          company.communication.length > 0
                        ">
                          <el-row :gutter="20" class="communication-item" v-for="item in company.communication"
                            :key="item.msg_id">
                            <el-col :span="2" style="text-align: center">
                              <el-avatar :size="45">
                                <img :src="
                                  item.user_header
                                    ? item.user_header
                                    : 'https://o.bysjy.com.cn/kzp/public/photo_default.png?x-oss-process=style/w64-h64'
                                " />
                              </el-avatar>
                            </el-col>
                            <el-col :span="22">
                              <div class="communication-main">
                                <p>
                                  <span class="c-name">{{
                                    item.user_name
                                  }}</span>
                                  <span class="c-time">{{
                                    item.create_time
                                  }}</span>
                                </p>
                                <p class="c-txt">
                                  {{ item.content }}
                                </p>
                              </div>
                              <div class="communication-rep" v-if="item.replies && item.replies.length > 0">
                                <p class="rep-item" v-for="rep in item.replies" :key="rep.reply_id">
                                  <span class="c-name">{{ rep.nick_name }}：</span>
                                  <span class="c-txt">{{ rep.content }}</span>
                                  <span class="c-time">{{
                                    rep.create_time
                                  }}</span>
                                </p>
                              </div>
                            </el-col>
                          </el-row>
                        </template>
                        <no-data v-else></no-data>
                      </div>
                      <el-row style="height: 50px" v-if="loadingPane" v-loading="loadingPane" element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"></el-row>

                      <el-divider v-if="grid.questionNoMore">
                        这是我的底线哦~
                      </el-divider>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </card-base>
            </el-col>
            <el-col :span="8">
              <card-base :style-object="style.top" :margin-object="style.topMargin" v-if="false">
                <el-row :gutter="10" class="icon-box" style="margin: 0 0 0.1rem">
                  <el-col :span="12">
                    <span class="icon-circle">
                      <!-- <i class="iconfont icongongzuotai"></i> -->
                      <i class="el-icon-camera"></i>
                    </span>
                    <span class="icon-text">企业实景</span>
                  </el-col>
                  <el-col :span="12" style="text-align: right">
                    <el-button v-loading="office_live_loading" icon="el-icon-refresh" size="mini" round
                      @click="officeLiveReload()">刷新
                    </el-button>
                    <a :href="company.company_info.office_live" :target="company.company_info.company_id + '_720vr'">
                      <el-button icon="el-icon-full-screen" size="mini" round>全屏
                      </el-button>
                    </a>
                  </el-col>
                </el-row>
                <iframe :src="company.company_info.office_live + office_live_version"
                  style="width: 100%; height: 500px"></iframe>
              </card-base>
              <card-base
                v-if="annualData && !annualData.is_expired && (annualData.material.video_url || annualData.material.allPic.length > 0)"
                :style-object="style.top" :margin-object="style.topMargin">
                <div class="company-annual">
                  <h2 class="icon-box" style="margin-top: 0" v-if="annualData.material.video_url">
                    <span class="icon-text">企业视频</span>
                  </h2>
                  <el-image v-if="annualData.material.video_url" @click="dialogVideoVisible = true" class="video-box"
                    src="https://o.bysjy.com.cn/kzp/annual/video-moren.png?temp=2022022501" fit="cover"></el-image>
                  <!-- <video class="video-box" object-fit="cover"
                                  :post="annualData.material.video_url"
                                 :src="annualData.material.video_url" v-if="annualData.material.video_url" ></video> -->
                  <h2 class="icon-box" style="margin-top: 0" v-if="annualData.material.allPic.length > 0">
                    <span class="icon-text">企业相册</span>
                  </h2>
                  <el-carousel height="1.75rem" :interval="5000" arrow="always"
                    v-if="annualData.material.allPic.length > 0">
                    <el-carousel-item v-for="(item, index) in annualData.material.allPic" :key="index">
                      <el-image class="carousel-img" style="height: 100%" fit="cover" :src="item"></el-image>
                    </el-carousel-item>
                  </el-carousel>
                  <div class="annual_tag" v-if="annualData.material.live_url.length > 0">平台认证</div>
                </div>
              </card-base>
              <card-base :style-object="style.top" :margin-object="style.topMargin">
                <div class="credit-info">
                  <div class="graphics-txt">
                    <p v-if="
                      credit_info.info_integrity_grade &&
                      credit_info.recruit_liveness_grade &&
                      credit_info.income_audit_grade
                    ">
                      <span class="iconfont iconxinyong credit-tip">{{
                        credit_info.info_integrity_grade +
                        credit_info.recruit_liveness_grade +
                        credit_info.income_audit_grade
                      }}</span>
                    </p>
                    <!-- 一个月存3k，每个月存850的房租，然后水电费交通费生活费一个月2000，那么一个月就剩下1500买娃...意味着一个月只能超生一个崽。可能还只是定金或者分期 -->
                    <p class="graphics-tip">云研企信等级</p>
                    <p>
                      超越
                      <span class="pect">{{ credit_info.percent_beat }}%</span>的校园招聘企业
                    </p>
                  </div>
                  <el-row :gutter="10" class="c-char-item">
                    <el-col :span="credit_info_config.span">
                      <div class="icon-wrap">
                        <img :src="credit_info_icon.info_integrity_icon" />
                      </div>
                      <p>资料完整度</p>
                      <p class="c-score-wrap">
                        {{ credit_info.info_integrity_grade }} ({{
                          credit_info.info_integrity_score
                        }}%)
                      </p>
                    </el-col>
                    <el-col :span="credit_info_config.span">
                      <div class="icon-wrap">
                        <img :src="credit_info_icon.recruit_liveness_icon" />
                      </div>
                      <p>招聘活跃度</p>
                      <p class="c-score-wrap">
                        {{ credit_info.recruit_liveness_grade }} ({{
                          credit_info.recruit_liveness_score
                        }}分)
                      </p>
                    </el-col>
                    <el-col :span="credit_info_config.span">
                      <div class="icon-wrap">
                        <img :src="credit_info_icon.income_audit_icon" />
                      </div>
                      <p>高校审核</p>
                      <p class="c-score-wrap">
                        {{ credit_info.income_audit_grade }} ({{
                          credit_info.income_audit_cnt
                        }}家)
                      </p>
                    </el-col>
                    <el-col :span="credit_info_config.span">
                      <div class="icon-wrap">
                        <img :src="credit_info_icon.complaint_icon" />
                      </div>
                      <p>学生投诉</p>
                      <p class="c-score-wrap">
                        {{ credit_info.complaint_cnt }}
                      </p>
                    </el-col>
                  </el-row>
                </div>
                <div style="padding: 10px 0;text-align:center;">
                  <el-button v-tyc-count key-value="pc_company_detail" :name="company.company_info.company_name"
                    size="mini" type="primary" icon="el-icon-search">工商查询</el-button>
                </div>
              </card-base>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
      <footer-box class="footerBox"></footer-box>
    </side-bar>
    <!--视频预览-->
    <el-dialog title="视频介绍" width="70%" :visible.sync="dialogVideoVisible">
      <video v-if="dialogVideoVisible" style="width: 100%;height: 100%;max-height: 600px;" controls="controls" autoplay
        loop :src="annualData.material.video_url"></video>
      <!-- <video  controls="controls" autoplay loop class="video-item" style="width: 100%;height: 100%;" src="annualInfo.material.video_url"></video> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import CardBase from '@/components/Card/CardBase'
// import BaiduMap from '@/components/Map/Map'

export default {
  name: 'company-detail',
  components: {
    CardBase,
    // BaiduMap
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
    scene_pics() {
      const { img_base, company } = this
      const { company_info } = company || {}
      let arr
      try {
        arr = JSON.parse(company_info.scene_pics)
      } catch (error) {
      }
      if (this.$util.isArrayFn(arr)) {
        const a = []
        arr.forEach((item) => {
          if (item && item.name) {
            a.push(img_base + item.name)
          }
        })
        return a
      } else {
        return []
      }
    },
    scene_schoolmate_pics() {
      const { schoolmate } = this.company.brand || []
      const a = []
      if (schoolmate) {
        schoolmate.forEach((item) => {
          if (item.img) {
            a.push(item.img)
          }
        })
      }
      return a
    },
    // trendsUrl (){
    //   // 登录之后再跳转页面
    //   let pageUrl = "/pages/seeker/company/detail/main?company_id="+this.company_id
    //   let link = base_url + encodeURIComponent( choose_url + encodeURIComponent(pageUrl));
    //   return link;
    // },
  },
  data() {
    return {
      headerNavbg: 'transparent',
      showIframeView: false,
      credit_info_config: {
        span: 12,
      },
      credit_info_icon: {
        info_integrity_icon: 'https://o.bysjy.com.cn/kzp/public/c1.png',
        recruit_liveness_icon: 'https://o.bysjy.com.cn/kzp/public/c2.png',
        income_audit_icon: 'https://o.bysjy.com.cn/kzp/public/c3.png',
        complaint_icon: 'https://o.bysjy.com.cn/kzp/public/c4.png',
      },
      img_base: 'https://o.bysjy.com.cn/',
      style: {
        top: {
          padding: '0.2rem',
        },
        topMargin: {
          marginBottom: '0.2rem',
        },
        map: { height: '2.65rem', width: '100%' },
        headerNav: { position: 'absolute' },
        cardBase1: { position: 'absolute', width: '1200px', top: '571px' }, // 571 618
        elRow: { paddingTop: '88px' }, // 68 115
      },
      company: {
        job_list: [],
        interviewer_info: [],
        company_info: {
          scene_pics: [],
        },
        brand: {
          schoolmate: [],
        },
        dynamic_list: [],
        dynamic_list_active: 0,
        icons: []
      },
      credit_info: {},
      tabsInfo: {
        active: 'info',
        list: ['info', 'job', 'dynamic', 'communication'],
      },
      company_id: '',
      question: '',
      pageParams: {
        questionPage: {
          pageNo: 1,
          pageSize: 10,
          company_id: '',
        },
        jobPage: {
          pageNo: 1,
          pageSize: 20,
          company_id: '',
        },
        dynamicPage: {
          pageNo: 1,
          pageSize: 10,
          company_id: '',
        },
      },
      loadingPane: false,
      grid: {
        questionHeight: 400,
        questionNoMore: false,
        jobNoData: false,
        jobHeight: 400,
        dynamicNoData: false,
        dynamicHeight: 400,
      },
      countDownTime: '',

      office_live_loading: false,
      office_live_version: '',
      dialogVideoVisible: false,//年审视频
      annualData: '',//年审信息
      funs_count: 0,//粉丝数
      is_funs: 0,//是否是粉丝
      trendsUrl: '',//企业动态小程序图
    }
  },
  created: function () {
    this.initHeight()
    this.init()
  },
  filters: {
    fomartTime: function (value) {
      if (value) {
        let arr = value.split('-')
        return arr[1] + '-' + arr[2]
      }
    },
  },
  methods: {
    initHeight() {
      if (this.tabsInfo.active === 'communication') {
        const height =
          window.innerHeight -
          document.querySelector('.header-nav').offsetHeight -
          document.querySelector('.card-base').offsetHeight -
          document.querySelector('.input-wrap').offsetHeight -
          220
        this.grid.questionHeight = height
      } else if (this.tabsInfo.active === 'job') {
        const height =
          window.innerHeight -
          document.querySelector('.header-nav').offsetHeight -
          document.querySelector('.card-base').offsetHeight -
          120
        this.grid.jobHeight = height
      } else if (this.tabsInfo.active === 'dynamic') {
        const height =
          window.innerHeight -
          document.querySelector('.header-nav').offsetHeight -
          document.querySelector('.card-base').offsetHeight -
          150
        this.grid.dynamicHeight = height
      }
    },
    initIframe() {
      if (!this.company.company_info.office_live) {
        this.headerNavbg = '1'
        this.style.elRow.paddingTop = '0'
        this.style.headerNav.position = 'unset'
        this.style.cardBase1.position = 'unset'
        this.style.cardBase1.top = '0'
      } else {
        this.headerNavbg = 'transparent'
        this.style.headerNav.position = 'absolute'
        this.style.cardBase1.position = 'absolute'
        this.style.cardBase1.top = '571px'
        this.style.elRow.paddingTop = '88px'
      }
    },
    getIframeView() {
      this.company.company_info.office_live
      this.showIframeView = true
      this.style.cardBase1.top = '618px'
      this.style.elRow.paddingTop = '135px'
    },
    init: function () {
      var tabs = this.$util.getQueryString('tabs') || ''
      if (this.tabsInfo.list.includes(tabs)) {
        this.tabsInfo.active = tabs
      }
      this.company_id = this.$util.getQueryString('company_id')
      this.getDetail()
      this.getDynamic()
      this.getMiniCode()
    },
    //获取小程序二维码
    getMiniCode() {
      let params = {
        scene: 'company_id=' + this.company_id,
        page: 'pages/seeker/company/detail/main',
        type: 'dynamic'
      }

      this.$util.get('kzp_person', 'programe_code', params).then((res) => {
        let { code, data, msg } = res
        if (code == 1) {
          this.trendsUrl = data
        }
      })
    },
    tabsChangeFn: function (a) {
      console.log('tabsChangeFn', a)
      this.initHeight()
    },
    getDetail: function () {
      let _self = this,
        company_id = this.company_id
      this.$util
        .get('kzp_person', 'company_detail', {
          company_id: company_id,
        })
        .then((res) => {

          if (res.code !== 1) {
            if (res.msg) {
              _self.$message.error(res.msg)
            }
            return
          }
          let { company, jobs, brand, bars, credit_info, icons, annual, funs_count, is_funs } = res.data
          if (credit_info) {
            _self.credit_info = credit_info
          }
          this.funs_count = funs_count;
          this.is_funs = is_funs

          // 百度地图：公司地址
          // _self.$refs['baidu-map'].mapFn({
          //   title: company.company_name,
          //   address: company.address,
          //   city: company.city_name,
          //   is_open: true,
          // })

          // 企业logo转换
          _self.$util.tansPics(company, 'logo_url', {
            default_img: _self.$util.error_company_logo,
          })

          if (annual) {
            if (!annual.is_expired && annual.office_video_live) {
              company.office_live = annual.office_video_live
            } else if (!annual.is_expired && annual.office_live) {
              company.office_live = annual.office_live
            }

            let allPic = [], material = annual.material;
            if (annual.material) {
              allPic = allPic.concat(material.live_url)
              allPic = allPic.concat(material.culture_url)
              allPic = allPic.concat(material.certification_url)
              allPic = allPic.concat(material.other_url)
            }
            annual.material = Object.assign(annual.material, {
              allPic: allPic
            })
          }
          // 公司信息
          _self.company = Object.assign(_self.company, {
            job_list: jobs ? jobs : [],
            company_info: company,
            communication: bars,
            brand: brand || {},
            icons: icons || []
          })
          _self.annualData = annual

          this.initIframe() // 处理是否存在360全景样式转换
        })
        .catch(() => {
          // 处理不提示的错误!
        })
    },
    jobDetail: function (publish_id) {
      this.$util.pageto('jobfair_job', {
        publish_id: publish_id,
      })
    },
    //获取数据公共方法
    ajaxFn(contr, action, type, params, sFn, stip, eFn) {
      let _self = this
      type = type || 'get'
      _self.loadingPane = true
      if (type === 'get') {
        _self.$util
          .get(contr, action, params)
          .then((res) => {
            const { data, msg, code } = res
            if (code === 1) {
              if (stip) _self.$message({ message: stip, type: 'success' })
              if (sFn && typeof sFn === 'function') {
                sFn(data)
              }
            } else {
              if (eFn && typeof eFn === 'function') {
                eFn(msg)
              } else {
                _self.$message.error(msg)
              }
            }
            _self.loadingPane = false
          })
          .catch(() => {
            // 处理不提示的错误!
          })
      } else {
        _self.$util
          .post(contr, action, params)
          .then((res) => {
            const { data, msg, code } = res
            if (code === 1) {
              if (stip) _self.$message({ message: stip, type: 'success' })
              if (sFn && typeof sFn === 'function') {
                sFn(data)
              }
            } else {
              if (eFn && typeof eFn === 'function') {
                eFn(msg)
              } else {
                _self.$message.error(msg)
              }
            }
            _self.loadingPane = false
          })
          .catch(() => {
            // 处理不提示的错误!
          })
      }
    },

    //region 互动交流
    //提交问题
    submitQuestion() {
      let _self = this
      if (!this.question) {
        this.$message.error('请输入你的问题')
      } else {
        this.$util
          .post('kzp_person', 'submit_question', {
            company_id: _self.company_id,
            question: _self.question,
            company_name: _self.company.company_info.company_name,
          })
          .then((res) => {
            const { code, msg } = res
            if (code === 1) {
              _self.$message({
                message: '提交问题成功，请等待HR的回复',
                type: 'success',
              })
              //重置问题
              _self.question = ''
              //开启倒计时
              _self.countDown()
              _self.refreshQuestion()
            } else {
              _self.$message.error(msg)
            }
          })
          .catch(() => {
            // 处理不提示的错误!
          })
      }
    },
    //获取互动交流
    getQuestion(type) {
      let _self = this
      if (type === 'refresh') {
        _self.pageParams.questionPage.pageNo = 1
        _self.grid.questionNoMore = false
      }
      _self.pageParams.questionPage.company_id = this.company_id
      _self.ajaxFn(
        'kzp_person',
        'get_question',
        'get',
        _self.pageParams.questionPage,
        function (data) {
          if (_self.pageParams.questionPage.pageNo === 1) {
            _self.company.communication = data
          } else {
            if (data.length < _self.pageParams.questionPage.pageSize) {
              _self.grid.questionNoMore = true
            }
            _self.company.communication = [
              ..._self.company.communication,
              ...data,
            ]
          }
        }
      )
    },
    //刷新问题列表
    refreshQuestion() {
      this.getQuestion('refresh')
    },
    //翻页加载问题
    loadNextQuestion() {
      if (this.loadingPane || this.grid.questionNoMore) return false
      this.pageParams.questionPage.pageNo++
      this.getQuestion()
    },
    //计时器
    countDown() {
      let self = this
      self.countDownTime = 15
      setInterval(function () {
        if (self.countDownTime > 1) {
          self.countDownTime--
        } else {
          self.countDownTime = ''
        }
      }, 1000)
    },
    //endregion

    //region 在招职位
    //获取在招职位列表
    getJobs() {
      let _self = this
      this.pageParams.jobPage.company_id = this.company_id
      _self.ajaxFn(
        'kzp_person',
        'get_jobs',
        'get',
        _self.pageParams.jobPage,
        function (data) {
          if (_self.pageParams.jobPage.pageNo === 1) {
            _self.company.job_list = data
          } else {
            if (data.length < _self.pageParams.jobPage.pageSize) {
              _self.grid.jobNoData = true
            }
            _self.company.job_list = [..._self.company.job_list, ...data]
          }
        }
      )
    },
    //翻页加载职位列表
    loadNextJobs() {
      if (this.loadingPane || this.grid.jobNoData) return false
      this.pageParams.jobPage.pageNo++
      this.getJobs()
    },
    //endregion

    //region 校招动态
    getDynamic() {
      let _self = this
      _self.pageParams.dynamicPage.company_id = this.company_id
      _self.ajaxFn(
        'kzp_person',
        'get_company_dynamic',
        'get',
        _self.pageParams.dynamicPage,
        function (data) {
          if (_self.pageParams.dynamicPage.pageNo === 1) {
            _self.$set(_self.company, 'dynamic_list', data)
          } else {
            if (data.length < _self.pageParams.dynamicPage.pageSize) {
              _self.grid.dynamicNoData = true
            }
            _self.company.dynamic_list = [
              ..._self.company.dynamic_list,
              ...data,
            ]
          }

          var nowTime = parseInt(new Date().getTime() / 1000) // 秒数
          var dynamic_long = _self.company.dynamic_list.length
          for (var i = 0; i < dynamic_long; i++) {
            var item = _self.company.dynamic_list[i]
            if (item.meet_time >= nowTime) {
              _self.company.dynamic_list_active = i
            } else {
              break
            }
          }
        }
      )
    },
    //翻页加载
    loadNextDynamic() {
      if (this.loadingPane || this.grid.dynamicNoData) return false
      this.pageParams.dynamicPage.pageNo++
      this.getDynamic()
    },
    //endregion
    officeLiveReload() {
      this.office_live_loading = true
      var _self = this

      var office_live = this.company.company_info.office_live

      var office_live_version = ''
      if (office_live.indexOf('?') > -1) {
        office_live_version = '&v='
      } else {
        office_live_version = '?v='
      }

      this.office_live_version = office_live_version + new Date().getTime()

      setTimeout(() => {
        _self.office_live_loading = false
      }, 2000)
    },
  },
}
</script>

<style lang="scss" scoped>
.f16 {
  font-size: 16px;
}
.headerBanner {
  width: 100%;

  .bannerImg {
    width: 100%;
    height: 618px;

    img {
      width: 100%;
      height: 100%;
    }

    .titile {
      position: absolute;
      top: 205px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 66px;
      color: #ffffff;
      text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      letter-spacing: 8px;
    }

    .view {
      position: absolute;
      top: 306px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(7, 7, 7, 0.09);
      border: 1px solid #ffffff;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.69);
      border-radius: 20px;
      font-size: 20px;
      color: #ffffff;
      letter-spacing: 3px;
      padding: 7px 21px;
      cursor: pointer;
    }

    .iframeView {
      position: absolute;
      top: 108px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.container {
  min-height: calc(100% - 68px);
}

.company-detail {
  height: 100%;

  .el-image {
    width: 100%;
  }

  .icon-box {
    $boxSize: 0.25rem;
    line-height: $boxSize;
    overflow: hidden;
    margin: 0.3rem 0 0.1rem;

    >span {
      float: left;
    }

    .icon-circle {
      display: inline-block;
      width: $boxSize;
      height: $boxSize;
      line-height: $boxSize;
      text-align: center;
      background-color: $lightColor;
      color: #fff;

      margin-right: 0.08rem;
      @include border-radius(50%);

      .iconfont {
        vertical-align: text-top;
        font-size: 0.12rem;
      }
    }

    .icon-text {
      display: inline-block;
      font-size: 0.18rem;
      line-height: $boxSize;
      font-weight: bold;
      color: #282828;
    }
  }

  .company-text {
    font-size: 0.14rem;
    font-weight: 500;
    color: #999999;
  }

  .company-bold-text {
    font-size: 0.16rem;
    font-weight: bold;
    color: #282828;
  }

  .company-business-info {
    line-height: 0.2rem;

    p {
      @extend .company-text;

      margin-bottom: 0.1rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .video-box {
    width: 100%;
    height: 1.75rem;
    border-radius: 10px;
    margin-bottom: 0.25rem;
    background: #f5f5f5;
  }

  .credit-info {
    $creditColor: #e98f36;
    text-align: center;

    .credit-tip {
      font-size: 0.18rem;
      color: $creditColor;
      font-weight: bold;
      margin: 0.15rem 0px 0.1rem;

      &.iconfont:before {
        font-size: 0.18rem !important;
      }
    }

    .graphics-txt {
      margin-bottom: 0.15rem;

      .graphics-tip {
        font-size: 0.14rem;
      }

      .pect {
        color: $creditColor;
      }
    }

    .c-char-item {
      text-align: center;

      .c-score-wrap {
        color: $creditColor;
      }

      .icon-wrap {
        width: 100%;
        height: 65px;

        img {
          width: 55px;
          height: 55px;
        }
      }
    }
  }

  .company-info {
    p {
      @include over-ellipsis();
    }

    p.text-introduce {
      margin-top: 0.07rem;

      .text-normal {
        border-right: 1px solid #999999;

        &:last-child {
          border-right: none;
        }
      }
    }

    .text-bold {
      font-size: 0.18rem;
      font-weight: bold;
      line-height: 0.25rem;
      color: #282828;
    }

    .text-normal {
      font-size: 0.12rem;
      font-weight: 400;
      line-height: 0.2rem;
      color: #999999;
      padding: 0 5px;
    }

    .text-light {
      font-size: 0.14rem;
      font-weight: bold;
      line-height: 0.2rem;
      color: #f6404d;
    }

    .text-highlight {
      color: $lightColor;
      font-size: 0.14rem;
      font-weight: bold;
      line-height: 0.2rem;
    }

    .text-normal-bold {
      font-size: 0.16rem;
      font-weight: 500;
      line-height: 0.22rem;
      color: #282828;
    }

    .card-tip {
      @include card-icons-tip(18px);
    }
  }

  .input-wrap {
    width: 80%;
    margin: 40px auto 20px;
  }

  .job-list-wrap {
    padding: 0 15px;

    .tip-txt {
      font-weight: normal;
      font-size: 15px;
      color: #999999;
      margin-left: 10px;
    }
  }

  .communication-list-wrap {
    padding: 0px 15px;
    overflow: hidden;

    .communication-item {
      margin: 10px 0px;
      border-bottom: 1px solid #eee;
      padding: 10px 0px;

      &:last-of-type {
        border: none;
      }
    }

    .communication-main {
      .c-name {
        font-size: 16px;
        color: #007fff;
      }

      .c-time {
        float: right;
      }

      .c-txt {
        margin: 5px 0px;
      }
    }

    .communication-rep {
      background: #f3f3f3;
      border-radius: 5px;
      padding: 5px 10px;
      position: relative;
      margin-top: 10px;

      .rep-item {
        padding: 5px;
        display: flex;

        .c-name {
          color: #007fff;
        }

        .c-txt {
          flex-grow: 1;
        }

        .c-time {
          display: block;
          width: 220px;
          text-align: right;
          flex: 0 0 220px;
        }
      }

      &:before {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;
        border-bottom: 10px solid #f3f3f3;
        position: absolute;
        top: -5px;
      }
    }
  }
}

.credit-info {
  $creditColor: #e98f36;
  text-align: center;

  .credit-tip {
    font-size: 0.18rem;
    color: $creditColor;
    font-weight: bold;
    margin: 0.15rem 0px 0.1rem;

    &.iconfont:before {
      font-size: 0.18rem !important;
    }
  }

  .graphics-txt {
    margin-bottom: 0.15rem;

    .graphics-tip {
      font-size: 0.14rem;
    }

    .pect {
      color: $creditColor;
    }
  }

  .c-char-item {
    text-align: center;

    .c-score-wrap {
      color: $creditColor;
    }

    .icon-wrap {
      width: 100%;
      height: 65px;

      img {
        width: 55px;
        height: 55px;
      }
    }
  }
}

.company-annual {
  position: relative;

  .annual_tag {
    position: absolute;
    z-index: 10;
    bottom: 1.35rem;
    right: 15px;
    padding: 0 10px;
    height: 25px;
    font-size: 12px;
    color: #fff;
    line-height: 27px;
    background: #158aff;
    border-radius: 25px;
    box-sizing: border-box;
  }

  .carousel-img {
    border-radius: 10px;
  }
}

.program-popover {
  display: flex;
  align-content: center;
  flex-direction: column;

  p {
    text-align: center;
  }

  .notice-text {
    color: #c5c5c5;
  }

  .code-img {
    width: 200px;
    height: 200px;
    margin: 0 auto 10px;
  }
}

.follow-btn {
  margin-right: 20px;
}

.fans-box {
  font-size: 14px;
  color: #999999;
  margin-bottom: 15px;

  .fans-num {
    font-size: 24px;
    color: #007fff;
    margin-right: 10px;
  }
}

.right-info-box {
  position: relative;
  z-index: 1;
  text-align: center;
}
</style>
<style>
.el-carousel__button {
  width: 5px;
  height: 5px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/seeker/company_detail/newApp.vue